import { render } from "./VirtualLearningEnvironmentView.vue?vue&type=template&id=83cfbf46&scoped=true"
const script = {}

import "./VirtualLearningEnvironmentView.vue?vue&type=style&index=0&id=83cfbf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83cfbf46"]])

export default __exports__